"use strict";

const APP_NG = "Nightguard";
const APP_DG = "Dayguard";
const APP_WHITE2= "Whitening";
const APP_WHITE = "Whitening Tray";
const APP_WHITE_BOTH = "Whitening Double Tray";

let app_activeSection = APP_NG;

let appBuyBtn_ID = document.getElementById("app-add-btn-id");


appBuyBtn_ID.addEventListener("click", clickedOnBuy);

appBuyBtn_ID.addEventListener("mouseenter", app_displayWhiteBasket);
appBuyBtn_ID.addEventListener("mouseleave", app_displayDarkBlueBasket);

// set the default basket colour for the add to basket button
app_displayDarkBlueBasket();

function app_displayDarkBlueBasket() {
    appBuyBtn_ID.style.backgroundImage = "url('dark_blue_basket.png')";
}

function app_displayWhiteBasket() {
    appBuyBtn_ID.style.backgroundImage = "url('white_basket.png')";
}

// handle recording the appliance that was ordered
function clickedOnBuy(){    
    console.log(app_activeSection);
    let item;
    if (app_activeSection !== null) {       
		var data = jQuery('#ajax-add-tocart').serialize();
      
      if(app_activeSection == APP_NG){
          var type= jQuery('.nightguard-type:checked').val();
          console.log(type);
          data += '&properties[Type]='+type;
        
      }
      if(app_activeSection == APP_WHITE2){
         if(jQuery('#whitening-lower-tray').is(':checked')){
              data += '&properties[Lower Tray]=Yes';
           }
         if(jQuery('#whitening-upper-tray').is(':checked')){
            data += '&properties[Upper Tray]=Yes';

         }
       }
         jQuery.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            dataType: 'json', 
            data: data,
            success: function(data){                
              item= app_activeSection;
              Toast.show(item + ' added to your basket', "added-to-basket");
              
             $.ajax({
                type: 'GET',
                url: '/cart.json',
                dataType: 'json',
                success: function(data) { 
                    var item_count = data.item_count;
                  $('#desktop-cart-item').html(item_count);
                  $('#mobile-cart-item').html(item_count);
                }
              });
            
            },
            error: function(){
           }
         });      
     
    } else {
        Toast.show("ERROR - No valid appliance selected!", "error");
    }
}

function getParameterByName( name ){
    var regexS = "[\\?&]"+name+"=([^&#]*)", 
  regex = new RegExp( regexS ),
  results = regex.exec( window.location.search );
  if( results == null ){
    return "";
  } else{
    return decodeURIComponent(results[1].replace(/\+/g, " "));
  }
}

function getWhiteningSection(){
        var tray = 0;
        if(jQuery('#whitening-lower-tray').is(':checked')){
           tray += 1;
         }
        if(jQuery('#whitening-upper-tray').is(':checked')){
           tray += 1;
        }
  
  	  $("#ProductSelect-variant option").each(function (){
             if($(this).attr('data-value') == "Whitening"){            
                  var img = $(this).attr('data-img');
                    jQuery('#app-selected-image-id').attr('src', img);
              }
        }); 

        if(tray == 1){
             $("#ProductSelect-variant option").each(function (){
                 $(this).removeAttr('selected'); 
                 if($(this).attr('data-value') == "Whitening"){
                   $("#ProductSelect-variant").val($(this).val());
                    $(this).attr('selected', 'selected'); 
                    var price = $(this).attr('data-price');
                   jQuery('.app-price').html(price);
                 }
              });     
        }
        if(tray == 2){         
               $("#ProductSelect-variant option").each(function (){
               $(this).removeAttr('selected'); 
                 if($(this).attr('data-value') == "Whitening-both"){
                   $("#ProductSelect-variant").val($(this).val());
                    $(this).attr('selected', 'selected'); 
                    var price = $(this).attr('data-price');
                   jQuery('.app-price').html(price);
                }
           }); 

       }
   
      if(tray == 0){
         	jQuery('#app-add-btn-id').attr('disabled', 'disabled');
            jQuery('.app-price').html('<span class="warning">Select at least one tray!</span>');
          console.log('tray', tray);
        } 
    else{
      jQuery('#app-add-btn-id').removeAttr('disabled');
    }
  
}


jQuery(document).ready(function(){  
  app_activeSection = APP_NG; 
  var get_variant = 'Nightguard';
  
  if(getParameterByName('app') == 'dayguard'){ 
      app_activeSection = APP_DG;
        jQuery('input[value="Dayguard"]').attr('checked', 'checked');
  }    
  if(getParameterByName('app') == 'whitening'){ 
      app_activeSection = APP_WHITE2;
      jQuery('input[value="Whitening"]').attr('checked', 'checked');
  } 
  
  $("#ProductSelect-variant option").each(function (){
        $(this).removeAttr('selected');        
          if($(this).attr('data-value') == app_activeSection){           
               $(this).attr('selected', 'selected'); ;
               var price = $(this).attr('data-price');
               var img = $(this).attr('data-img');
               jQuery('#app-selected-image-id').attr('src', img);
               jQuery('.app-price').html(price);
         }
     });
   
 // console.log('after fr', $("#ProductSelect-variant").val()); 
  //console.log('app_activeSection', app_activeSection);
  jQuery('.custom-pro-desc').css('display', 'none');
  jQuery('.'+app_activeSection+'').css('display', 'block');
  // end of default loading code
  
  
 jQuery('.custom-tray-selection').click(function(){
    app_activeSection = APP_WHITE2;
   // console.log('beforeq', $("#ProductSelect-variant").val());
    getWhiteningSection();
  });
  
  
   jQuery('.app-Appliance').click(function(){
     	  jQuery('.pp-dial-patterninput').removeAttr('checked');
     	  jQuery('#app-add-btn-id').removeAttr('disabled');
     	  jQuery(this).attr('checked', 'checked');
           var get_variant = jQuery(this).attr('data-value');    
           app_activeSection = get_variant;     
             
           jQuery('.custom-pro-desc').css('display', 'none');
           jQuery('.'+get_variant+'').css('display', 'block');  //get desc and image
       
         // console.log('gv', get_variant);
        //  console.log('before', $("#ProductSelect-variant").val());
        
     console.log('app_activeSection', app_activeSection);
         if(app_activeSection == APP_WHITE2 || app_activeSection == APP_WHITE_BOTH ){          
              getWhiteningSection();
         }else{
             jQuery("#ProductSelect-variant option").each(function (){
                 jQuery(this).removeAttr('selected'); 
                // console.log('dv', jQuery(this).attr('data-value'));
             });
            jQuery("#ProductSelect-variant option").each(function (){
             if(jQuery(this).attr('data-value') == get_variant){
                jQuery(this).attr('selected', 'selected'); 
                var price = $(this).attr('data-price');
                var img = $(this).attr('data-img');
                jQuery('#app-selected-image-id').attr('src', img);
                jQuery('.app-price').html(price);
               jQuery("#ProductSelect-variant").val(jQuery(this).attr('value'))
             }
               
               
          });
     
        }
       
     //  console.log('after check', $("#ProductSelect-variant").val());
       
     });
  

 });